var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgHandGrid(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("defs", null, React.createElement("path", {
    id: "hand-grid_svg__a",
    d: "M0 0h4.5v1.5H0z"
  }), React.createElement("path", {
    id: "hand-grid_svg__c",
    d: "M0 0h4.5v1.5H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M11.75 14h-3l-.102.007A.75.75 0 008.75 15.5h3l.102-.007A.75.75 0 0011.75 14m3-2.5h3l.102-.007A.75.75 0 0017.75 10h-3l-.102.007a.75.75 0 00.102 1.493m-3-1.5h-3l-.102.007A.75.75 0 008.75 11.5h3l.102-.007A.75.75 0 0011.75 10"
  }), React.createElement("g", {
    transform: "translate(20 6)"
  }, React.createElement("mask", {
    id: "hand-grid_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#hand-grid_svg__a"
  })), React.createElement("path", {
    fill: "currentColor",
    d: "M.75 1.5h3l.102-.007A.75.75 0 003.75 0h-3L.648.007A.75.75 0 00.75 1.5",
    mask: "url(#hand-grid_svg__b)"
  })), React.createElement("path", {
    fill: "currentColor",
    d: "M14.75 7.5h3l.102-.007A.75.75 0 0017.75 6h-3l-.102.007A.75.75 0 0014.75 7.5"
  }), React.createElement("g", {
    transform: "translate(20 10)"
  }, React.createElement("mask", {
    id: "hand-grid_svg__d",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#hand-grid_svg__c"
  })), React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 0h-3L.648.007A.75.75 0 00.75 1.5h3l.102-.007A.75.75 0 003.75 0",
    mask: "url(#hand-grid_svg__d)"
  })), React.createElement("path", {
    fill: "currentColor",
    d: "M11.75 6h-3l-.102.007A.75.75 0 008.75 7.5h3l.102-.007A.75.75 0 0011.75 6m3 9.5h3l.102-.007A.75.75 0 0017.75 14h-3l-.102.007a.75.75 0 00.102 1.493"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M16.645 20.293a.504.504 0 00.502-.505v-.509c0-.311.25-.564.557-.564a.56.56 0 01.556.564v.509c0 .278.226.505.503.505a.504.504 0 00.502-.505v-.509a.56.56 0 01.556-.564c.307 0 .557.253.557.564v.509c0 .278.225.505.502.505a.504.504 0 00.502-.505v-5.16a.56.56 0 01.557-.564.56.56 0 01.557.564v9.331c0 .845-.68 1.531-1.516 1.531h-4.435a1.524 1.524 0 01-1.515-1.531v-4.68a.56.56 0 01.556-.564.56.56 0 01.557.564v.509c0 .278.225.505.502.505m5.294-7.238c-.861 0-1.561.706-1.561 1.573v3.181a1.598 1.598 0 00-1.615.315c-.573-.531-1.546-.53-2.118 0a1.559 1.559 0 00-1.059-.418 1.57 1.57 0 00-1.561 1.573v4.68c0 1.401 1.131 2.541 2.52 2.541h4.435c1.39 0 2.52-1.14 2.52-2.541v-9.331c0-.867-.7-1.573-1.561-1.573"
  })));
}

export default SvgHandGrid;